import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70d83f58"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("1 ADA = ") + " ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AmountText = _resolveComponent("AmountText")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!

  return (_openBlock(), _createBlock(_component_a_skeleton, {
    active: "",
    paragraph: { rows: 0 },
    loading: _ctx.fetchUsdRateLoading,
    class: "my-0 current-exchange-rate__skeleton"
  }, {
    default: _withCtx(() => [
      _createElementVNode("b", null, [
        _hoisted_1,
        (_ctx.usdRateData?.data?.amount)
          ? (_openBlock(), _createBlock(_component_AmountText, {
              key: 0,
              class: "d-inline",
              amount: _ctx.usdRateData?.data?.amount,
              minPrecision: 2,
              "max-precision": 2,
              "currency-code": "USD"
            }, null, 8, ["amount"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}